import { useEffect } from "react"
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Alert, Box, CircularProgress } from "@mui/material";

import { PageBlockWrapper } from "../ui/PageBlockWrapper";
import { Table } from "../ui/table/Table/Table";
import { PageNavigation } from "../ui/Navigation";
import { toggleForm } from "../store/formSlice";
import { useQueryEntityData } from "../hooks/useQueryEntityData";
import { QueryResults } from "../repository/models_v2";

export const ResultsPage = () => {
    const { slug } = useParams()
    const dispatch = useDispatch()

    const {data, error} = useQueryEntityData(slug!)

    useEffect(() => {
        if(!!data?.page.total_items_exact){
            dispatch(toggleForm(false))
        }
    },[data, dispatch])

    const isCompleteData = !!data && !!slug

    const results: QueryResults = isCompleteData ? data._embedded["item"] : null
    const quantity = isCompleteData ? data.page.total_items_exact : 0

    const resultsTitle = !!data?.page?.total_items_estimate ? 'Resultaten: '+quantity : ''

    if(error !== null ){
        if (error?.statusCode === 403) {
            return <Alert severity='error'>No Permissions.</Alert>
        } else {
            return <Alert severity='error'>Something went wrong, please try again or contact your system administrator.</Alert>
        }
    }

    return (
        <PageBlockWrapper
            withoutSpacings
            header={quantity > data?.page?.size ? (
                <Header
                    nextLink={data?._links.next?.href ?? ''}
                    prevLink={data?._links.prev?.href ?? ''}
                />
            ) : null}
        >
            {results === null ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>
            ) : <></>}

            <Table rows={results} title={resultsTitle} />
        </PageBlockWrapper>
    )
}

interface HeaderProps {
    prevLink?: string,
    nextLink?: string
}

const Header = ({ nextLink, prevLink }: HeaderProps) => {
    return (
        <PageNavigation nextLink={nextLink} prevLink={prevLink} />
    )
}
